import { COMMON_COMPONENT_TYPES, COMMON_COMPONENT_NAMES, CONDITION_OPERATORS_DATASOURCE, NODE_TYPES, APPLICATION_TYPES } from "constants/flowDesigner";

const nodeType = NODE_TYPES.COMMON;

const retrySettings = () => [
   {
      field: "maximumRetries",
      label: "Maximum retries",
      type: "number",
      value: 2,
      min: 0,
      max: 5,
      placeholder: "0 - 5"
   },
   {
      field: "initialRetryDelayMs",
      label: "Initial retry delay (milliseconds)",
      type: "number",
      value: 1000,
      min: 0,
      max: 30000,
      placeholder: "0 - 30000"
   },
   {
      field: "maximumRetryDelayMs",
      label: "Maximum retry delay (milliseconds)",
      type: "number",
      value: 30000,
      min: 0,
      max: 60000,
      placeholder: "0 - 60000"
   }
];

const commonComponentsMockData = {
   [COMMON_COMPONENT_TYPES.MCP_CLIENT]: {
      type: nodeType,
      key: COMMON_COMPONENT_TYPES.MCP_CLIENT,
      name: COMMON_COMPONENT_NAMES.MCP_CLIENT,
      payloadable: false,
      documentation: "https://cxfabric.io/docs/#/developer-tools/components/components/mcp-client",
      actions: [{
         actionID: "CC_mcp_configure",
         actionName: "MCP Client",
         isCredentialSupported: true,
         applicationType: [APPLICATION_TYPES.BEARER],
         dataInsideAction: [
            { field: "serverUrl", label: "Server URL", type: "text", placeholder: "https://example.com/mcp", isRequired: true },
            {
               field: "authenticationType",
               label: "Authentication",
               type: "dropdown",
               value: "none",
               options: [
                  { value: "none", text: "None" },
                  { value: APPLICATION_TYPES.BEARER, text: "Bearer token" }
               ],
               isRequired: true
            },
            { field: "selectedItem", label: "Tool", placeholder: "Enter the exact tool name", type: "text", isRequired: true, hideUntilOAuthAuthenticated: true },
            { field: "arguments", label: "Arguments", type: "json", value: "{}", placeholder: "Enter a JSON object or a flow reference", hideUntilOAuthAuthenticated: true }
         ]
      }]
   },
   [COMMON_COMPONENT_TYPES.SELECTION]: {
      type: nodeType,
      key: COMMON_COMPONENT_TYPES.SELECTION,
      name: COMMON_COMPONENT_NAMES.SELECTION,
      payloadable: false,
      documentation: "https://cxfabric.io/docs/#/developer-tools/components/components/selection",
      actions: [
         {
            actionID: "CC_0",
            actionName: "Expected Results",
            dataInsideAction: []
         }
      ]
   },
   [COMMON_COMPONENT_TYPES.CONDITIONAL]: {
      type: nodeType,
      key: COMMON_COMPONENT_TYPES.CONDITIONAL,
      name: COMMON_COMPONENT_NAMES.CONDITIONAL,
      payloadable: false,
      documentation: "https://cxfabric.io/docs/#/developer-tools/components/components/conditional",
      actions: [
         {
            actionID: "CC_1",
            actionName: "Expected Results",
            dataInsideAction: [
               {
                  field: "inputValue",
                  label: "Input value",
                  type: "text",
                  placeholder: ""
               },
               {
                  field: "operator",
                  label: "Operator",
                  type: "dropdown",
                  options: CONDITION_OPERATORS_DATASOURCE,
                  placeholder: ""
               },
               {
                  field: "valueToCompareWith",
                  label: "Value to compare with",
                  type: "text",
                  placeholder: ""
               }
            ]
         }
      ]
   },
   [COMMON_COMPONENT_TYPES.EXECUTION_REPORT]: {
      type: nodeType,
      key: COMMON_COMPONENT_TYPES.EXECUTION_REPORT,
      name: COMMON_COMPONENT_NAMES.EXECUTION_REPORT,
      payloadable: false,
      documentation: "https://cxfabric.io/docs/#/operate-and-govern/execution-evidence-and-audit",
      actions: [
         {
            actionID: "CC_2",
            actionName: "Results",
            dataInsideAction: [
               {
                  field: "page",
                  label: "Show Results on a Page",
                  type: "checkbox",
                  placeholder: "",
                  disabled: false,
                  value: true
               }
            ]
         }
      ]
   },
   [COMMON_COMPONENT_TYPES.VARIABLES]: {
      type: nodeType,
      key: COMMON_COMPONENT_TYPES.VARIABLES,
      name: COMMON_COMPONENT_NAMES.VARIABLES,
      payloadable: false,
      documentation: "https://cxfabric.io/docs/#/developer-tools/components/components/variables",
      actions: [
         {
            actionID: "CC_3",
            actionName: "Variables",
            dataInsideAction: [
               {
                  field: "addVariable",
                  label: "Add New",
                  type: "button"
               },
               {
                  field: "addOutputReference",
                  label: "Add New",
                  type: "button"
               }
            ]
         }
      ]
   },
   [COMMON_COMPONENT_TYPES.REST_API]: {
      type: nodeType,
      key: COMMON_COMPONENT_TYPES.REST_API,
      name: COMMON_COMPONENT_NAMES.REST_API,
      payloadable: true,
      documentation: "https://cxfabric.io/docs/#/developer-tools/components/components/rest-client",
      actions: [
         {
            actionID: "CC_6",
            actionName: "REST API",
            isCredentialSupported: true,
            applicationType: [APPLICATION_TYPES.AWS, APPLICATION_TYPES.BEARER, APPLICATION_TYPES.BASIC_AUTH],
            dataInsideAction: [
               {
                  key: "divider-0",
                  type: "divider",
                  label: "Divider"
               },
               {
                  field: "method",
                  label: "Method",
                  type: "dropdown",
                  value: "GET",
                  options: [
                     {
                        value: "GET",
                        text: "GET"
                     },
                     {
                        value: "POST",
                        text: "POST"
                     },
                     {
                        value: "PUT",
                        text: "PUT"
                     },
                     {
                        value: "PATCH",
                        text: "PATCH"
                     },
                     {
                        value: "DELETE",
                        text: "DELETE"
                     }
                  ]
               },
               {
                  key: "divider-1",
                  type: "divider",
                  label: "Divider"
               },
               {
                  field: "endpoint",
                  type: "text",
                  label: "Endpoint",
                  placeholder: "Endpoint",
                  isRequired: true
               },
               {
                  key: "divider-2",
                  type: "divider",
                  label: "Divider"
               },
               {
                  field: "parameters",
                  type: "list",
                  label: "Parameters",
                  listItems: [
                     {
                        field: "params",
                        label: "Parameters",
                        type: "keyValue"
                     },
                     {
                        field: "addParameter",
                        type: "button",
                        label: "Add Parameter"
                     }
                  ]
               },
               {
                  key: "divider-3",
                  type: "divider",
                  label: "Divider"
               },
               {
                  field: "headers",
                  type: "list",
                  label: "Headers",
                  listItems: [
                     {
                        field: "headers",
                        label: "Headers",
                        type: "keyValue"
                     },
                     {
                        field: "addHeader",
                        type: "button",
                        label: "Add Header"
                     }
                  ]
               },
               {
                  key: "divider-5",
                  type: "divider",
                  label: "Divider"
               },
               {
                  field: "payloadContentType",
                  label: "Payload Content Type",
                  type: "list",
                  listItems: [
                     {
                        field: "payloadContentType",
                        label: "Payload Content Type",
                        type: "dropdown",
                        value: "json",
                        options: [
                           { value: "formData", text: "Form Data" },
                           { value: "json", text: "JSON" }
                        ],
                        placeholder: ""
                     },
                     {
                        field: "payload",
                        label: "Payload",
                        type: "editor"
                     }
                  ]
               },
               ...retrySettings()
            ]
         }
      ]
   },
   [COMMON_COMPONENT_TYPES.WEBHOOK]: {
      type: nodeType,
      key: COMMON_COMPONENT_TYPES.WEBHOOK,
      name: COMMON_COMPONENT_NAMES.WEBHOOK,
      payloadable: true,
      documentation: "https://cxfabric.io/docs/#/developer-tools/components/components/webhook-client",
      actions: [
         {
            actionID: "CC_20",
            actionName: "Webhook",
            isCredentialSupported: true,
            applicationType: [APPLICATION_TYPES.AWS, APPLICATION_TYPES.BEARER, APPLICATION_TYPES.BASIC_AUTH],
            dataInsideAction: [
               {
                  key: "divider-0",
                  type: "divider",
                  label: "Divider"
               },
               {
                  field: "method",
                  label: "Method",
                  type: "dropdown",
                  value: "POST",
                  options: [
                     {
                        value: "GET",
                        text: "GET"
                     },
                     {
                        value: "POST",
                        text: "POST"
                     },
                     {
                        value: "PUT",
                        text: "PUT"
                     },
                     {
                        value: "PATCH",
                        text: "PATCH"
                     }
                  ]
               },
               {
                  key: "divider-1",
                  type: "divider",
                  label: "Divider"
               },
               {
                  field: "endpoint",
                  type: "text",
                  label: "Endpoint",
                  placeholder: "Endpoint",
                  isRequired: true
               },
               {
                  field: "receiverUrl",
                  type: "text",
                  label: "URL(Receiver of the response)",
                  placeholder: "Receiver"
               },
               {
                  key: "divider-2",
                  type: "divider",
                  label: "Divider"
               },
               {
                  field: "parameters",
                  type: "list",
                  label: "Parameters",
                  listItems: [
                     {
                        field: "params",
                        label: "Parameters",
                        type: "keyValue"
                     },
                     {
                        field: "addParameter",
                        type: "button",
                        label: "Add Parameter"
                     }
                  ]
               },
               {
                  key: "divider-3",
                  type: "divider",
                  label: "Divider"
               },
               {
                  field: "headers",
                  type: "list",
                  label: "Headers",
                  listItems: [
                     {
                        field: "headers",
                        label: "Headers",
                        type: "keyValue"
                     },
                     {
                        field: "addHeader",
                        type: "button",
                        label: "Add Header"
                     }
                  ]
               },
               {
                  key: "divider-5",
                  type: "divider",
                  label: "Divider"
               },
               {
                  field: "payloadContentType",
                  label: "Payload Content Type",
                  type: "list",
                  listItems: [
                     {
                        field: "payloadContentType",
                        label: "Payload Content Type",
                        type: "dropdown",
                        value: "json",
                        options: [
                           { value: "formData", text: "Form Data" },
                           { value: "json", text: "JSON" }
                        ],
                        placeholder: ""
                     },
                     {
                        field: "payload",
                        label: "Payload",
                        type: "editor"
                     }
                  ]
               },
               ...retrySettings()
            ]
         }
      ]
   },
   [COMMON_COMPONENT_TYPES.EMAIL]: {
      type: nodeType,
      key: COMMON_COMPONENT_TYPES.EMAIL,
      name: COMMON_COMPONENT_NAMES.EMAIL,
      payloadable: false,
      documentation: "https://cxfabric.io/docs/#/developer-tools/components/components/email",
      actions: [
         {
            actionID: "CC_7",
            actionName: "Email",
            isCredentialSupported: true,
            applicationType: [APPLICATION_TYPES.SMTP],
            dataInsideAction: [
               {
                  field: "from",
                  label: "From",
                  type: "text",
                  placeholder: "From",
                  isRequired: true
               },
               {
                  field: "recipients",
                  label: "Recipients",
                  type: "tag",
                  placeholder: "Recipient",
                  isRequired: true,
                  isMultiple: true
               },
               {
                  field: "cc",
                  label: "Cc",
                  type: "tag",
                  placeholder: "Cc",
                  isNotRequired: true
               },
               {
                  field: "bcc",
                  label: "Bcc",
                  type: "tag",
                  placeholder: "Bcc",
                  isMultiple: true
               },
               {
                  field: "subject",
                  label: "Subject",
                  type: "text",
                  placeholder: "Subject",
                  isRequired: true
               },
               {
                  field: "content",
                  label: "Content",
                  type: "text",
                  placeholder: "Content",
                  multiline: true,
                  isRequired: true
               },
               {
                  field: "attachments",
                  label: "Attachments",
                  type: "file",
                  multiple: true
               },
               ...retrySettings()
            ]
         }
      ]
   },
   [COMMON_COMPONENT_TYPES.DATABASE]: {
      type: nodeType,
      key: COMMON_COMPONENT_TYPES.DATABASE,
      name: COMMON_COMPONENT_NAMES.DATABASE,
      payloadable: true,
      documentation: "https://cxfabric.io/docs/#/developer-tools/components/components/microsoft-sql-database",
      actions: [
         {
            actionID: "CC_8",
            actionName: "Database",
            isCredentialSupported: true,
            applicationType: [APPLICATION_TYPES.DATABASE],
            dataInsideAction: [
               {
                  field: "sqlStatement",
                  label: "SQL Statement",
                  type: "sql",
                  placeholder: "SQL Statement",
                  multiline: true,
                  isRequired: true
               },
               ...retrySettings()
            ]
         }
      ]
   },
   [COMMON_COMPONENT_TYPES.SFTP]: {
      type: nodeType,
      key: COMMON_COMPONENT_TYPES.SFTP,
      name: COMMON_COMPONENT_NAMES.SFTP,
      payloadable: true,
      documentation: "https://cxfabric.io/docs/#/developer-tools/components/components/sftp",
      actions: [
         {
            actionID: "CC_8",
            actionName: "SFTP",
            isCredentialSupported: true,
            applicationType: [APPLICATION_TYPES.SFTP],
            dataInsideAction: [
               {
                  field: "operation",
                  label: "Operation",
                  type: "dropdown",
                  options: [
                     { value: "download", text: "Download" },
                     { value: "list", text: "List files" },
                     { value: "upload", text: "Upload" }
                  ]
               }
            ]
         }
      ]
   },
   [COMMON_COMPONENT_TYPES.GOTO]: {
      type: nodeType,
      key: COMMON_COMPONENT_TYPES.GOTO,
      name: COMMON_COMPONENT_NAMES.GOTO,
      payloadable: false,
      documentation: "https://cxfabric.io/docs/#/developer-tools/components/components/go-to",
      actions: [
         {
            actionID: "CC_9",
            actionName: "Go To",
            dataInsideAction: [
               {
                  field: "nodeId",
                  label: "Select node",
                  type: "dropdown",
                  options: []
               }
            ]
         }
      ]
   },
   [COMMON_COMPONENT_TYPES.DELAY]: {
      type: nodeType,
      key: COMMON_COMPONENT_TYPES.DELAY,
      name: COMMON_COMPONENT_NAMES.DELAY,
      payloadable: false,
      documentation: "https://cxfabric.io/docs/#/developer-tools/components/components/delay",
      actions: [
         {
            actionID: "CC_10",
            actionName: "DELAY",
            dataInsideAction: [
               {
                  field: "delayAmount",
                  label: "Delay Amount",
                  type: "text",
                  placeholder: "1 - 999",
                  isRequired: true
               },
               {
                  field: "timeUnit",
                  label: "Time Unit",
                  type: "dropdown",
                  value: "seconds",
                  options: [
                     { value: "milliseconds", text: "Milliseconds" },
                     { value: "seconds", text: "Seconds" },
                     { value: "minutes", text: "Minutes" }
                  ]
               }
            ]
         }
      ]
   },
   [COMMON_COMPONENT_TYPES.CODE]: {
      type: nodeType,
      key: COMMON_COMPONENT_TYPES.CODE,
      name: COMMON_COMPONENT_NAMES.CODE,
      payloadable: true,
      documentation: "https://cxfabric.io/docs/#/developer-tools/components/components/code",
      actions: [
         {
            actionID: "CC_11",
            actionName: "Code",
            dataInsideAction: [
               {
                  field: "language",
                  label: "Language",
                  type: "dropdown",
                  value: "javascript",
                  options: [
                     { value: "javascript", text: "Javascript" },
                     { value: "typescript", text: "Typescript" }
                  ]
               },
               {
                  field: "code",
                  label: "Code",
                  type: "code"
               }
            ]
         }
      ]
   },
   [COMMON_COMPONENT_TYPES.REDIS]: {
      type: nodeType,
      key: COMMON_COMPONENT_TYPES.REDIS,
      name: COMMON_COMPONENT_NAMES.REDIS,
      payloadable: false,
      documentation: "https://cxfabric.io/docs/#/developer-tools/components/components/redis",
      actions: [
         {
            actionID: "CC_14",
            actionName: "Publish",
            isCredentialSupported: true,
            applicationType: [APPLICATION_TYPES.REDIS],
            dataInsideAction: [
               {
                  field: "topic",
                  label: "Topic",
                  type: "text",
                  placeholder: "Topic",
                  isRequired: true
               },
               {
                  field: "message",
                  label: "Message",
                  type: "text",
                  placeholder: "Your message",
                  isRequired: true
               },
               {
                  field: "targetFlowId",
                  label: "Target flow id",
                  type: "text",
                  placeholder: "Target flow id",
                  isRequired: true
               }
            ]
         },
         {
            actionID: "CC_15",
            actionName: "Get",
            isCredentialSupported: true,
            applicationType: [APPLICATION_TYPES.REDIS],
            dataInsideAction: [
               {
                  field: "key",
                  label: "Key",
                  type: "text",
                  placeholder: "Key",
                  isRequired: true
               }
            ]
         },
         {
            actionID: "CC_16",
            actionName: "Set",
            isCredentialSupported: true,
            applicationType: [APPLICATION_TYPES.REDIS],
            dataInsideAction: [
               {
                  field: "key",
                  label: "Key",
                  type: "text",
                  placeholder: "Key",
                  isRequired: true
               },
               {
                  field: "value",
                  label: "Value",
                  type: "text",
                  placeholder: "Value",
                  isRequired: true
               }
            ]
         },
         {
            actionID: "CC_17",
            actionName: "HmGet",
            isCredentialSupported: true,
            applicationType: [APPLICATION_TYPES.REDIS],
            dataInsideAction: [
               {
                  field: "key",
                  label: "Key",
                  type: "text",
                  placeholder: "Key",
                  isRequired: true
               },
               {
                  field: "fields",
                  label: "Fields",
                  type: "simpleTag",
                  placeholder: "Enter fields",
                  isRequired: true
               }
            ]
         },
         {
            actionID: "CC_18",
            actionName: "HSet",
            isCredentialSupported: true,
            applicationType: [APPLICATION_TYPES.REDIS],
            dataInsideAction: [
               {
                  field: "key",
                  label: "Key",
                  type: "text",
                  placeholder: "Key",
                  isRequired: true
               },
               {
                  field: "field_1",
                  label: "Field 1",
                  type: "string",
                  placeholder: "",
                  value: "",
                  secondaryInput: {
                     field: "fValue_1",
                     value: "",
                     label: "Default value 1",
                     placeholder: "",
                     isRequired: true
                  },
                  isRequired: true
               },
               {
                  field: "addField",
                  label: "Add New",
                  type: "button"
               }
            ]
         }
      ]
   },
   [COMMON_COMPONENT_TYPES.END]: {
      type: nodeType,
      key: COMMON_COMPONENT_TYPES.END,
      name: COMMON_COMPONENT_NAMES.END,
      payloadable: false,
      documentation: "https://cxfabric.io/docs/#/developer-tools/components/components/end",
      actions: []
   },
   [COMMON_COMPONENT_TYPES.DATA_LOGGER]: {
      type: nodeType,
      key: COMMON_COMPONENT_TYPES.DATA_LOGGER,
      name: COMMON_COMPONENT_NAMES.DATA_LOGGER,
      payloadable: false,
      documentation: "https://cxfabric.io/docs/#/developer-tools/components/components/data-logger",
      actions: [
         {
            actionID: "CC_19",
            actionName: "Logging",
            isCredentialSupported: false,
            applicationType: [APPLICATION_TYPES.REDIS],
            dataInsideAction: [
               {
                  field: "payload",
                  label: "Payload reference",
                  type: "text",
                  placeholder: "Payload reference",
                  isRequired: true
               },
               {
                  field: "tags",
                  label: "Tags",
                  type: "simpleTag",
                  placeholder: "Enter tags"
               },
               {
                  field: "level",
                  label: "Level",
                  type: "dropdown",
                  value: "info",
                  options: [
                     { value: "info", text: "Info" },
                     { value: "warn", text: "Warn" },
                     { value: "error", text: "Error" },
                     { value: "debug", text: "Debug" }
                  ]
               },
               {
                  field: "sessionId",
                  label: "Session Id",
                  type: "text",
                  placeholder: "Session Id"
               }
            ]
         }
      ]
   },
   [COMMON_COMPONENT_TYPES.INVOKE]: {
      type: nodeType,
      key: COMMON_COMPONENT_TYPES.INVOKE,
      name: COMMON_COMPONENT_NAMES.INVOKE,
      payloadable: true,
      documentation: "https://cxfabric.io/docs/#/developer-tools/components/components/invoke",
      actions: [
         {
            actionID: "CC_20",
            actionName: "Invoke",
            dataInsideAction: [
               {
                  field: "flowId",
                  label: "Select flow",
                  type: "selectWithDetails",
                  isRequired: "true",
                  options: []
               },
               {
                  field: "runSynchronously",
                  label: "Run synchronously",
                  type: "checkbox",
                  placeholder: "",
                  disabled: false,
                  value: true
               },
               {
                  key: "divider-1",
                  type: "divider",
                  label: "Divider"
               },
               {
                  field: "parameters",
                  type: "list",
                  label: "Parameters",
                  listItems: [
                     {
                        field: "params",
                        label: "Parameters",
                        type: "keyValue"
                     },
                     {
                        field: "addParameter",
                        type: "button",
                        label: "Add Parameter"
                     }
                  ]
               }
            ]
         }
      ]
   },
   [COMMON_COMPONENT_TYPES.SESSION_STORAGE]: {
      type: nodeType,
      key: COMMON_COMPONENT_TYPES.SESSION_STORAGE,
      name: COMMON_COMPONENT_NAMES.SESSION_STORAGE,
      payloadable: false,
      documentation: "https://cxfabric.io/docs/#/developer-tools/components/components/session-storage",
      actions: [
         {
            actionID: "CC_21",
            actionName: "Session Storage",
            isCredentialSupported: false,
            dataInsideAction: [
               {
                  field: "action",
                  label: "Action",
                  type: "dropdown",
                  isRequired: true,
                  options: [
                     { value: "check", text: "Check" },
                     { value: "createIfNew", text: "Create If New" },
                     { value: "retrieve", text: "Retrieve" },
                     { value: "update", text: "Update" },
                     { value: "delete", text: "Delete" }
                  ]
               },
               {
                  field: "sessionId",
                  label: "Session ID",
                  type: "text",
                  placeholder: "Session ID",
                  isRequired: true
               }
            ]
         }
      ]
   },
   [COMMON_COMPONENT_TYPES.RESPOND]: {
      type: nodeType,
      key: COMMON_COMPONENT_TYPES.RESPOND,
      name: COMMON_COMPONENT_NAMES.RESPOND,
      payloadable: true,
      documentation: "https://cxfabric.io/docs/#/developer-tools/components/components/respond",
      actions: [
         {
            actionID: "CC_21",
            actionName: "RESPOND",
            dataInsideAction: [
               {
                  field: "headers",
                  type: "list",
                  label: "Headers",
                  listItems: [
                     {
                        field: "headers",
                        label: "Headers",
                        type: "keyValue"
                     },
                     {
                        field: "addHeader",
                        type: "button",
                        label: "Add Header"
                     }
                  ]
               },
               {
                  field: "responseType",
                  label: "Response",
                  type: "list",
                  listItems: [
                     {
                        field: "responseType",
                        label: "Response Type",
                        type: "dropdown",
                        value: "plaintext",
                        options: [
                           { value: "json", text: "JSON" },
                           { value: "plaintext", text: "Text" }
                        ],
                        placeholder: ""
                     },
                     {
                        field: "response",
                        label: "Response",
                        type: "editor"
                     }
                  ]
               }
            ]
         }
      ]
   }
};

export default commonComponentsMockData;
